import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

const dictionary = {
  'from_price.card_from_frictionless_flow': {
    'en-GB': 'Card From',
    'nl-NL': 'Kaart vanaf',
  },
  'from_price.copy_frictionless_flow': {
    'en-GB': 'Select size in the next step',
    'nl-NL': 'Kies de maat in de volgende stap',
  },
  'from_price.copy': {
    'en-GB': 'From',
    'nl-NL': 'Vanaf',
  },
}

export const useLocaleText = createLocaleTextHook({
  dictionary,
})
